import React from 'react';
import PropTypes from 'prop-types';
import { connectToModel, bindToPath } from 'client/data/luckdragon/redux/react-binding';
import { EditorialReviewModel, EditorialReviewEntities, buildReviewPath } from 'client/data/models/editorial-review';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { CorePageParams } from 'site-modules/shared/utils/core-page/params';

import { EditorialReviewBody } from './editorial-review-body';
import { isUsedDataAvailable } from './utils';

import './editorial-review.scss';

function EditorialReviewUI({
  editorialReview = null,
  vehicle = null,
  embeddedModules = null,
  isUsed = false,
  params,
  hasRouteYearParam = false,
  showHighlights = false,
  showBodyScorecard = false,
  expandReview = false,
  isReordered = false,
  showBottomHr = true,
}) {
  if (!editorialReview || (isUsed && !isUsedDataAvailable(editorialReview))) {
    return null;
  }
  const { reviewLink, firstContent } = editorialReview;

  // All vehicle after 2017(included) has grouped review
  const { articles, media } = firstContent;
  const hasRelatedArticles = firstContent && ((articles && articles.length > 0) || (media && media.length > 0));

  if (!reviewLink && !hasRelatedArticles) {
    return null;
  }

  const reviewBody = (
    <EditorialReviewBody
      params={params}
      vehicle={vehicle}
      embeddedModules={embeddedModules}
      hasRouteYearParam={hasRouteYearParam}
      showHighlights={showHighlights}
      forceShowScorecard={showBodyScorecard}
      expandReview={expandReview}
      isReordered={isReordered}
    />
  );

  // Show FL/FD content if has no editorial review
  if (!reviewLink) {
    return <div className="preprod-article">{reviewBody}</div>;
  }

  return (
    <div className="editorial-review-container">
      {reviewBody}
      {showBottomHr && <hr className="mt-1_5 mb-2" />}
    </div>
  );
}

EditorialReviewUI.propTypes = {
  params: CorePageParams.isRequired,
  editorialReview: EditorialReviewEntities.EditorialReview,
  vehicle: VehicleEntities.MakeModelSubmodelYear,
  embeddedModules: PropTypes.shape({
    coreSrpModule: PropTypes.node,
  }),
  isUsed: PropTypes.bool,
  hasRouteYearParam: PropTypes.bool,
  showHighlights: PropTypes.bool,
  showBodyScorecard: PropTypes.bool,
  expandReview: PropTypes.bool,
  isReordered: PropTypes.bool,
  showBottomHr: PropTypes.bool,
};

export const EditorialReview = connectToModel(EditorialReviewUI, {
  editorialReview: bindToPath(({ params }) => buildReviewPath(params), EditorialReviewModel),
});
